import { supabase } from './supabase';
import type { CompanyLink } from '../types/Entities';
import { listCompaniesCore, createCompanyCore, updateCompanyCore, deleteCompanyCore } from '@gv/core';

export type CompanyRow = {
    id: string;
    contact_id: string;
    name: string;
    role_title: string | null;
    website: string | null;
    email: string | null;
    phone: string | null;
    logo_url: string | null;
    created_at?: string;
    updated_at?: string;
};

export async function listCompanies(contactId: string): Promise<CompanyLink[]> {
    const rows = await listCompaniesCore(supabase, contactId);
    return rows as unknown as CompanyLink[];
}

export async function createCompany(contactId: string, link: CompanyLink): Promise<CompanyLink> {
    const saved = await createCompanyCore(supabase, contactId, link as any);
    return saved as unknown as CompanyLink;
}

export async function updateCompany(id: string, link: CompanyLink): Promise<CompanyLink> {
    const updated = await updateCompanyCore(supabase, id, link as any);
    return updated as unknown as CompanyLink;
}

export async function deleteCompany(id: string): Promise<void> {
    await deleteCompanyCore(supabase, id);
}
